// src/theme/typography.js
// AI temasına uygun modern fontlar ve temel tipografi ayarları.
// "Inter" ve "Roboto Mono" gibi fontların projenize dahil edildiğinden (örn: Google Fonts ile) emin olun.

const typography = {
  fonts: {
    heading: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    mono: `"Roboto Mono", SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`,
  },
  fontSizes: {
    // Mobil için optimize edilmiş font boyutları
    xs: "0.6875rem",  // 11px (mobil için biraz küçültüldü)
    sm: "0.8125rem",  // 13px (mobil için optimize)
    md: "0.9375rem",  // 15px (mobil için base boyut)
    lg: "1.0625rem",  // 17px (mobil için optimize)
    xl: "1.1875rem",  // 19px (mobil için optimize)
    '2xl': "1.375rem",  // 22px (mobil için optimize)
    '3xl': "1.625rem",  // 26px (mobil için optimize)
    '4xl': "2rem",      // 32px (mobil için optimize)
    '5xl': "2.5rem",    // 40px (mobil için optimize)
    '6xl': "3rem",      // 48px (mobil için optimize)
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,   // Kısa metinler, başlıklar için
    short: 1.375,
    base: 1.5,       // Mobil için daha kompakt
    tall: 1.65,      // Mobil için optimize
    taller: "1.85",  // Mobil için optimize
  },
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },
};

export default typography;
